<template>
  <div class="searchAndResultsPage">
    <div class="mainCont">
      <!-- 查询条件 -->
      <div class="searchRequirement">
        <div class="select">
          <div class="track disFlex">
            <el-input
              v-model="trackData"
              type="textarea"
              rows="10"
              resize="none"
              class="trackArea"
              :class="{consignment: trackType === '0'}"
              :placeholder="$t('spww.placeholder')"
            />
            <!-- <div class="btn ubiTrackBox" :style="searchBtnStyle" @click="truckingNoTrack" /> -->
            <div class="btn ubiTrackBox" @mouseenter="searchBtnHover = true" @mouseleave="searchBtnHover = false" @click="truckingNoTrack">
              <img v-show="!searchBtnHover" :src="options.btnBgi" alt="">
              <img v-show="searchBtnHover" :src="options.btnBgiHover" alt="">
            </div>
          </div>
          <div class="contactUs">
            <svg-icon icon-class="phone" />+86 400-017-6662
            <svg-icon class="email-icon" icon-class="email" />ubics-dlc@gotoubi.com
          </div>
        </div>
      </div>
      <!-- 查询结果 -->
      <div class="searchResult">
        <div v-for="(item, index) in resTrackData" :key="index" class="item">
          <div v-if="!item.notExist" :ref="getOrderItemRef(index)" class="order-item">
            <div class="order-txt">
              <span class="title">{{ item.name }}</span>
              <a class="track_up_down_box" @click="changeDetails(item)">
                <span>{{ $t("common.details") }}</span>
                <img class="track_up_down" :src="item.deailFlag ? detials_arrow_up_img : detials_arrow_down_img" alt="">
              </a>
            </div>
            <!-- 节点信息 -->
            <div class="order-hd">
              <div class="state-rcol">
                <div v-for="(cell, idx) in nodes" :key="cell.id" class="order-proces">
                  <div v-if="idx !== 0" class="proceArrow">
                    <img class="track_arrow" :src="handelProcess(cell.id, item.headerLight)" alt="">
                  </div>
                  <div class="node ready" :class="{'bigWidth': cell.id === 'SCN'}">
                    <div class="topIcon">
                      <img class="nodeIcon" style="width: 43px;height: 43px;" :src="handelNode(cell.id, item.headerLight)" alt="">
                    </div>
                    <div class="bodyPart" :class="{'hasLight': item.headerLight[cell.id].curLight}">
                      <div class="title">{{ cell.title }}</div>
                      <div class="time">{{ item.headerLight[cell.id].timestamp }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 详情信息 -->
            <div v-show="item.deailFlag" class="order-bd">
              <div class="event-list">
                <ul :ref="getUlRef(index)">
                  <li v-for="(evtItem, evtIndex) in item.trackDetails" :key="evtIndex" :class="{'first': evtIndex === 0}">
                    <i class="node-icon" />
                    <span class="date">{{ evtItem.date }}</span>
                    <span class="txt">
                      <span class="location">{{ evtItem.location }}</span>
                      <span v-if="!evtItem.showA" class="activity">{{ evtItem.activity }}</span>
                      <span v-if="evtItem.showA" class="activity">
                        <a :href="evtItem.url" target="_blank">{{ evtItem.activity }}</a>
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <!-- 更多信息 -->
              <div v-if="item.webSiteInfo.length > 0" class="forFurtherInformation">
                <div class="title">{{ $t("spww.forFurtherInformation") }}:</div>
                <div class="websites">
                  <!-- 查询网址 -->
                  <div v-for="(siteItem, siteIndex) in item.webSiteInfo" :key="siteIndex" class="site">
                    <span class="left description"> {{ siteItem.description }} </span>
                    <a class="right" :href="siteItem.webSite" target="_blank">{{ siteItem.webSite }}</a>
                  </div>
                </div>
              </div>
              <!-- 操作按钮 -->
              <div class="order-btn">
                <el-button type="primary" size="small" @click="onCopy($event, item, index)"> {{ $t("common.copy") }} </el-button>
                <el-button type="primary" size="small" @click="onTranslate(item, index)"> {{ $t("common.translate") }} </el-button>
              </div>
            </div>
          </div>
          <div v-if="item.notExist" class="noRes">
            <span class="weight">{{ item.name }}</span>
            <span>{{ $t("spww.noEventFound") }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 复制成功/失败 -->
    <CopyDialog v-show="showCopyDialog" ref="copyDialog" :copy-tips="copyTips" :new-ubi-style="true" />
    <!-- 翻译 -->
    <TranslateDialog v-show="showTranslateDialog" ref="translateDialog" :new-ubi-style="true" @changeLanTo="changeLanTo" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Clipboard from 'clipboard'
import RETURN_DATA from '@/utils/data/spww.js'
import { translateUrl, newTruckingNoTrack } from '@/api/truck.js'
import CopyDialog from '@/components/CopyDialog/index'
import TranslateDialog from '@/components/TranslateDialog/index'
import baseUrl from '@/utils/baseUrl'
export default {
  components: {
    CopyDialog,
    TranslateDialog
  },
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    trackType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      baseURL: baseUrl,
      nodes: [...RETURN_DATA().nodes],
      trackData: '',
      trackArr: [],
      resTrackData: [],
      detials_arrow_up_img: require('@/assets/images/spww/detials_arrow_up.png'),
      detials_arrow_down_img: require('@/assets/images/spww/detials_arrow_down.png'),
      INFICON: require('@/assets/images/spww/INF.png'),
      INFICON_DONE: require('@/assets/images/spww/INF_g.png'),
      RCVICON: require('@/assets/images/spww/RCV.png'),
      RCVICON_DONE: require('@/assets/images/spww/RCV_g.png'),
      SCNICON: require('@/assets/images/spww/SCN.png'),
      SCNICON_DONE: require('@/assets/images/spww/SCN_g.png'),
      LHLICON: require('@/assets/images/spww/LHL.png'),
      LHLICON_DONE: require('@/assets/images/spww/LHL_g.png'),
      SCNDESICON: require('@/assets/images/spww/SCN_DES.png'),
      SCNDESICON_DONE: require('@/assets/images/spww/SCN_DES_g.png'),
      DLDICON: require('@/assets/images/spww/DLD.png'),
      DLDICON_DONE: require('@/assets/images/spww/DLD_g.png'),
      proceIcons: require('@/assets/images/spww/proce-icons.png'),
      proceIcons_DONE: require('@/assets/images/spww/proce-icons-success.png'),
      showCopyDialog: false,
      copyTips: '',
      showTranslateDialog: false,
      curTransIndex: '',
      searchBtnHover: false
    }
  },
  computed: {
    ...mapGetters(['trackingNo']),
    language() {
      return this.$store.getters.language
    },
    initFromLan() {
      return 'auto'
    },
    searchBtnStyle() {
      return {
        '--backgroundImage': 'url(' + this.options.btnBgi + ')',
        '--hoverBackgroundImage': `url(${this.options.btnBgiHover ? this.options.btnBgiHover : this.options.btnBgi})`
      }
    }
  },
  watch: {
    $route(to, from) {
      // 在路由变化时执行
      this.handleTrackData()
    }
  },
  created() {
    this.handleTrackData()
  },
  mounted() {
  },
  methods: {
    // 处理TrackingNo自动查询
    handleTrackData() {
      this.setTrackDataFromUrlParams()
      if (!this.trackData) {
        this.trackData = this.trackingNo.replaceAll(',', '\n')
      }
      this.truckingNoTrack()
    },
    // 支持UBI的定制域名后拼接TrackingNo进行查询跟踪轨迹,
    // https://ubi.etowertech.com/#/ubi?trackingNos=xx,xx,xx
    setTrackDataFromUrlParams() {
      const url = window.location.href
      if (!url.includes('trackingNos')) return
      const paramsString = url.split('?')[1]
      if (!paramsString) return
      const paramsArray = paramsString.split('&')
      const paramsDict = paramsArray.reduce((dict, item) => {
        const [key, value] = item.split('=')
        dict[key] = decodeURIComponent(value)
        return dict
      }, {})
      const trackingNos = paramsDict['trackingNos']
      if (!trackingNos) return
      const trackingStr = trackingNos.split(',').join('\n')
      this.trackData = trackingStr
    },
    handelProcess(id, headerLight) {
      const { arrowLight } = headerLight[id] || false
      let str = 'proceIcons'
      if (arrowLight) str += '_DONE'
      return this[str]
    },
    handelNode(id, headerLight) {
      const { curLight } = headerLight[id] || false
      let str = id + 'ICON'
      if (curLight) str += '_DONE'
      return this[str]
    },
    truckingNoTrack() {
      this.resTrackData = []
      let trackData = this.trackData
      let trackArr = trackData.split('\n').map(item => item.trim()).filter(item => item)
      const trackingNo = trackArr.join(',')
      this.trackArr = this.arrayToUpperCaseAndNoRepeat(trackArr)
      if (!trackingNo) {
        this.trackData = ''
        return
      }
      let { hostname = '' } = location
      const systemHost = localStorage.getItem('systemHost')
      if (systemHost && systemHost !== 'null' && systemHost !== 'undefined') {
        hostname = systemHost
      }
      let params = {
        trackingNo,
        serverName: hostname
      }
      if (this.trackType) params.trackType = this.trackType
      newTruckingNoTrack(this.baseURL, params).then(res => {
        this.dealTrack(res.data)
      })
    },
    dealTrack(data) {
      this.resTrackData = []
      for (let i = 0; i < data.trackParcelEvents.length; i++) {
        let item = data.trackParcelEvents[i]
        // 处理节点信息
        const headerLight = this.getTrackHead(item.events)
        // 处理详情信息
        const trackDetails = this.getTrackBody(item.events)
        let obj = {
          name: item.trackingNo,
          notExist: false,
          deailFlag: false,
          events: item.events,
          headerLight,
          trackDetails,
          webSiteInfo: item.webSites
        }
        this.resTrackData.push(obj)
      }
      for (let i = 0; i < data.missTrackingNos.length; i++) {
        let item = data.missTrackingNos[i]
        this.resTrackData.push({
          name: item,
          notExist: true
        })
      }
      for (let i = 0; i < data.missConsignmentIds.length; i++) {
        let item = data.missConsignmentIds[i]
        this.resTrackData.push({
          name: item,
          notExist: true
        })
      }
    },
    getTrackHead(events) {
      let getHeaderData = {}
      this.nodes.forEach(item => {
        let node = item
        let hasNode = false
        let event = null
        let code = item.id
        getHeaderData[item.id] = {
          arrowLight: false,
          curLight: false,
          timestamp: '',
          title: item.title
        }
        events.forEach(cell => {
          const { eventCode, activity, sourceEventCode = '' } = cell
          if (node.code === eventCode && node.activity === activity) {
            hasNode = true
            event = cell
          } else if (node.code === eventCode && sourceEventCode !== null && sourceEventCode !== '' && node.invented_code === 'SCN_DES') {
            hasNode = true
            event = cell
          } else if (node.code === eventCode && eventCode === 'DLD') {
            hasNode = true
            event = cell
          } else if (node.code === eventCode && activity === 'DEPARTED FROM ORIGIN PORT') {
            hasNode = true
            event = cell
            code = code + '_SEA'
          } else if (node.code === eventCode && activity === 'READY TO DEPARTED FROM RAILWAY STATION') {
            hasNode = true
            event = cell
            code = code + '_TRAIN'
          } else if (node.code === eventCode && activity === 'TRANSPORT TO DSTK') {
            hasNode = true
            event = cell
          }
        })
        if (node.invented_code === 'SCN_DES') {
          code = 'SCN_DES'
        }
        // if (i > 0 && i < 6) {
        //   if (hasNode) {
        //     getHeaderData[item.id].arrowLight = true
        //   }
        // }
        if (hasNode) {
          getHeaderData[item.id].arrowLight = true
          getHeaderData[item.id].timestamp = event.timestamp || ''
          getHeaderData[item.id].curLight = true
        }
      })
      return getHeaderData
    },
    getTrackBody(events) {
      let trackDetails = []
      events.forEach(item => {
        let caTrackingUrl = 'https://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?trackingNumber=' + item.sourceTrackingNo + '&LOCALE=en&LOCALE2=en'
        let obj = {
          date: item.timestamp || '',
          location: (() => {
            const inner = [item.location, item.localTimeZone].filter(Boolean).join(' ')
            return inner ? `【${inner}】` : ''
          })(),
          activity: item.activity || '',
          showA: false && item.destCountry === 'CA',
          url: caTrackingUrl
        }
        trackDetails.push(obj)
      })
      return trackDetails
    },
    arrayToUpperCaseAndNoRepeat(array) {
      const newArray = []
      for (let i = 0; i < array.length; i++) {
        let value = array[i]
        newArray.push(value.toUpperCase())
      }
      // 去重
      var arrayResult = []
      for (let i = 0; i < newArray.length; i++) {
        if (arrayResult.indexOf(newArray[i]) === -1) {
          arrayResult.push(newArray[i])
        }
      }
      return arrayResult
    },
    changeDetails(item) {
      item.deailFlag = !item.deailFlag
    },
    onCopy(event, item, curIndex) {
      let trackno = `${this.$t('spww.trackingNo')}：${item.name} ${this.$t('common.details')}`
      let strArr = []
      strArr.push(trackno)
      const { trackDetails } = item
      const curList = this.$refs['list' + curIndex][0].querySelectorAll('li')
      curList.forEach((element, idx) => {
        let cellStr = `${trackDetails[idx].date}  ${element.lastChild.innerText}`
        strArr.push(cellStr)
      })
      // 处理更多信息、查询网址
      const forMoreInfo = this.$refs['orderItem' + curIndex][0].querySelector('.forFurtherInformation')
      const forMoreInfoText = forMoreInfo ? forMoreInfo.innerText : ''
      strArr.push(forMoreInfoText)
      let text = strArr.join('\n')
      const clipboard = new Clipboard(event.target, { text: () => text })
      clipboard.on('success', event => {
        this.copyTips = this.$t('common.copySuccess')
        this.$refs.copyDialog.showDialog = true
        setTimeout(() => {
          this.$refs.copyDialog.showDialog = false
        }, 600)
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', event => {
        // 不支持复制
        this.copyTips = this.$t('common.copyFailed')
        this.$refs.copyDialog.showDialog = true
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(event)
    },
    getUlRef(index) {
      return `list${index}`
    },
    getOrderItemRef(index) {
      return `orderItem${index}`
    },
    onTranslate(item, curIndex) {
      const { curLan } = item
      if (!curLan) this.$set(item, 'curLan', this.initFromLan)
      if (item.curLan && item.curLan === this.initFromLan) { // 初始化语言数据
        const curList = this.$refs['list' + curIndex][0].querySelectorAll('li')
        const initTexts = []
        curList.forEach(element => {
          initTexts.push(element.lastChild.innerText)
        })
        this.$set(item, 'initTexts', initTexts)
        // 处理更多信息、查询网址
        const forMoreEle = this.$refs['orderItem' + curIndex][0].querySelector('.forFurtherInformation')
        const moreEleInitText = forMoreEle ? forMoreEle.querySelector('.title').innerText : ''
        this.$set(item, 'moreEleInitText', moreEleInitText)
        const siteList = forMoreEle ? forMoreEle.querySelectorAll('.site') : []
        const descriptionInitText = []
        siteList.forEach(element => {
          const text = element.querySelector('.description').innerText
          descriptionInitText.push(text)
        })
        this.$set(item, 'descriptionInitText', descriptionInitText)
      }
      this.curTransIndex = curIndex
      this.$refs.translateDialog.showDialog = true
    },
    changeLanTo(langKey) {
      let from = this.initFromLan
      let to = langKey
      this.resTrackData[this.curTransIndex].curLan = to
      const { initTexts, moreEleInitText, descriptionInitText } = this.resTrackData[this.curTransIndex]
      let newTexts = initTexts.map((item, idx) => {
        return { flag: 1, text: item, idx }
      }).concat([{ flag: 2, text: moreEleInitText }]).concat(descriptionInitText.map((item, idx) => {
        return { flag: 3, text: item, idx }
      }))
      newTexts = newTexts.filter(item => item.text)
      newTexts.forEach((item, index) => {
        if (from !== to) {
          setTimeout(() => {
            let params = {
              sourceLanguageCode: from,
              targetLanguageCode: to,
              text: item.text
            }
            translateUrl(params, this.baseURL).then(res => {
              const resData = res.data || ''
              this.handelText(item.flag, item.idx, true, resData)
            }).catch(error => {
              console.log('翻译功能暂时不能使用，请稍后再试, 谢谢！', error)
            })
          }, index * 1300)
        } else { // 目标语言和初始语言一致则不调用接口
          this.handelText(item.flag, item.idx, false)
        }
      })
    },
    handelText(flag, idx, isApiBack = false, resData = '') {
      let value = resData
      if (flag === 1) {
        if (!isApiBack) {
          value = this.resTrackData[this.curTransIndex].initTexts[idx]
        }
        this.$refs['list' + this.curTransIndex][0].querySelectorAll('li')[idx].lastChild.innerText = value
      }
      if (flag === 2) {
        if (!isApiBack) {
          value = this.resTrackData[this.curTransIndex].moreEleInitText
        }
        this.$refs['orderItem' + this.curTransIndex][0].querySelector('.forFurtherInformation').querySelector('.title').innerText = value
      }
      if (flag === 3) {
        if (!isApiBack) {
          value = this.resTrackData[this.curTransIndex].descriptionInitText[idx]
        }
        this.$refs['orderItem' + this.curTransIndex][0].querySelector('.forFurtherInformation').querySelectorAll('.site')[idx].querySelector('.description').innerText = value
      }
    }
  }
}
</script>
<style lang='scss' scoped>
  .searchAndResultsPage {
    .mainCont {
      padding: 0 15px 10px;
      font-size: 12px;
      .searchRequirement {
        .select {
          padding: 0 15px 8px;
          .track {
            margin: 0 0 10px;
            justify-content: center;
          }
          .trackArea {
            width: 580px;
            margin:0 20px 0 0;
            &.consignment {
              /deep/textarea {
                border-color: $menuBgcOragne;
              }
            }
            /deep/textarea {
              height: 220px;
              max-height:220px;
              border-radius: 10px;
              border: 1px solid $menuBgcBox2Blue;
              /* box-shadow: 0px 0px 10px 0px rgba(3,60,128,0.3); */
              padding: 5px;
              color: #023C7F;
            }
          }
          .ubiTrackBox {
              width: 150px;
              height: 220px;
              border: none;
              cursor: pointer;
              background: var(--backgroundImage);
          }
          .ubiTrackBox:hover {
            background: var(--hoverBackgroundImage);
          }
          .contactUs {
            padding-right: 170px;
            font-size: 14px;
            color: $menuBgcBox2Blue;
            font-family: $fontFamilyArialBoldMT;
            display: flex;
            align-items: center;
            justify-content: center;
            .phone-icon {
              margin-right: 5px;
            }
            .email-icon {
              margin-left: 20px;
              margin-right: 5px;
            }
          }
        }
      }
      .searchResult {
        word-wrap: break-word;
        font-size: 15px;
        .item {
          .order-item {
            margin-bottom: 30px;
            border-bottom: 4px solid #f5f5f5;
            .order-txt {
              margin-bottom: 10px;
              font-weight: bold;
              .title {
                color: #023C7F;
                padding-right: 20px;
              }
              .track_up_down_box {
                padding: 5px 10px;
                color: #fff;
                background-color: #033C80;
                border-radius: 6px;
                font-size: 12px;
                &:hover {
                  background-color: #85BAE5;
                }
                .track_up_down {
                  cursor: pointer;
                  margin-top: 0px;
                  padding-left: 10px;
                }
              }
            }
            .order-hd {
              margin-left: 25px;
              .state-rcol {
                display: flex;
                // align-items: center;
                // justify-content: space-between;
                padding: 20px 0 0 0;
                .order-proces {
                  display: flex;
                  .node {
                    text-align: center;
                    width: 124px;
                    &.bigWidth {
                      width: 132px;
                    }
                    .topIcon {
                    }
                    .bodyPart {
                      .title {
                        font-size: 12px;
                        line-height: 25px;
                        color: #323232;
                        font-weight: bold;
                      }
                      .time {
                        padding:0 0 5px;
                        color: #aaa;
                        line-height: 15px;
                        font-size: 13px;
                      }
                      &.hasLight {
                        .title {
                          color: #023C7F;
                        }
                        .time {
                          color: #023C7F;
                        }
                      }
                    }
                  }
                  .proceArrow {
                    width: 41px;
                    margin-top: 12px;
                    // margin-right: 10px;
                    .track_arrow {
                      width: 100%
                    }
                  }
                }
              }
            }
            .order-bd {
              padding-bottom: 36px;
              ul {
                margin-left: 44px;
                margin-top: 16px;
                font-size: 12px;
                li {
                  position: relative;
                  padding: 15px 0 0 15px;
                  line-height: 22px;
                  border-left: 1px solid #d9d9d9;
                  font-size: 0;
                  color: #323232;
                  &.first {
                    padding: 0px 0 0 15px;
                    font-weight: bold;
                    color: #033C80;
                    .node-icon {
                      background: #023C7F;
                      margin-top: -6px;
                    }
                  }
                  .node-icon {
                    position: absolute;
                    left: -5px;
                    top: 50%;
                    width: 8px;
                    height: 8px;
                    background: #C3C3C3;
                    border-radius: 50%;
                  }
                  .txt {
                    max-width: 505px;
                    vertical-align: top;
                    font-size: 12px;
                  }
                  .date {
                    display: inline-block;
                    width: 100px;
                    border-radius: 14px;
                    font-size: 12px;
                    text-align: left;
                    margin-right: 25px;
                  }
                }
              }
              .forFurtherInformation {
                font-size: 12px;
                padding: 16px 0 0 44px;
                .title {
                  padding-bottom: 3px;
                }
                .websites {
                  .site {
                    padding-bottom: 2px;
                    .left {
                    }
                    .right {
                      color: #023C7F;
                      text-decoration: underline;
                    }
                  }
                }
              }
              .order-btn {
                margin-top: 10px;
                button {
                  color: #023C7F;
                  background-color: $menuBgcOragne;
                  border-color: $menuBgcOragne;
                  font-size: 12px;
                  margin-left: 25px;
                  border-radius: 6px;
                  width: 70px;
                  padding-left: 0;
                  padding-right: 0;
                  &:hover {
                    color: #fff;
                    background-color: #023C7F;
                    border-color: #023C7F;
                  }
                }
              }
            }
          }
          .noRes {
            margin-bottom: 20px;
            color: #023C7F;
            background: $menuBgcOragne;
            border-radius: 3px;
            padding: 6px 15px;
            font-size: 15px;
            border-bottom: 1px solid transparent;
            .weight {
              font-weight: bold;
            }
          }
        }
      }
    }
    .disFlex {
      display: flex;
      .fixWidth {
        padding-right:5px;
      }
      .remain {
        flex: 1
      }
    }
  }
</style>
